import React, { Component, Fragment } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import NewBacthSubproyectoForm from "./NewBacthSubproyectoForm";

class NewBatchSubproyectoModal extends Component {
  state = {
    modal: false
  };

  toggle = () => {
    this.setState(
      (previous) => ({
        modal: !previous.modal,
      }),
      () => {
        // Log modal state and check if resetState is being called
        console.log(`Modal state: ${this.state.modal}`);
        if (!this.state.modal && this.props.resetState) {
          console.log("Calling resetState to refresh the table.");
          this.props.resetState();
        }
      }
    );
  };

  render() {
    const create = this.props.create;

    var title = "Editando Batch Proyecto";
    var button = <Button 
      color="success"
      onClick={this.toggle}
      size="sm" block
      >
      Editar Batch
      </Button>;
    if (create) {
      title = "Creando Nuevo Bundle";

      button = (
        <Button
          color="warning"
          className="float-end"
          onClick={this.toggle}
          style={{ minWidth: "200px" }}
          size="sm" block
        >
          Crear Nuevo Bundle X
        </Button>
      );
    }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>

          <ModalBody>
            <NewBacthSubproyectoForm
              resetState={this.props.resetState}
              toggle={this.toggle}
              proyecto={this.props.subproyecto}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default NewBatchSubproyectoModal;